import React from "react";
import { MessageCircle } from "lucide-react";

// Last chance to spot a typo before paying.
export const ContactRecap = ({ phone, email, testid = "contact-recap" }) => {
  if (!phone && !email) return null;
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-black/8 bg-paper-muted/60 px-4 py-3" data-testid={testid}>
      <MessageCircle className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" aria-hidden="true" />
      <p className="text-sm text-ink-soft">
        <span className="font-semibold text-ink">Booking details go to:</span>{" "}
        <span className="text-ink">{[phone ? `WhatsApp: ${phone}` : "", email].filter(Boolean).join(" · ")}</span>
      </p>
    </div>
  );
};

export default ContactRecap;
